import { addPlaceholderForEmptyValues } from '@heidi-pay/heidi-common-fe/utils/addPlaceholderForEmptyValues';
import { GetLocaleDate, Translate } from '@hooks/useI18n';
import { IApplicationDocuments } from '@schemas/merchantPortal/types/orderApplicationDetails';
import { IApplicationDocumentData } from '../../types';
import { getFileNameFromPath } from '.';

interface IMapPaymentDataProps {
  data?: IApplicationDocuments;
  getLocaleDate: GetLocaleDate;
  translate: Translate;
}

export const mapApplicationDocumentData = ({
  data,
  getLocaleDate,
  translate,
}: IMapPaymentDataProps): IApplicationDocumentData[] =>
  data?.map(dataRow => {
    const { created, path, type, uuid } = dataRow;

    return addPlaceholderForEmptyValues<IApplicationDocumentData>({
      created: getLocaleDate({ date: created }),
      fileName: getFileNameFromPath(path, uuid),
      uuid,
      type: translate(`LABEL.APPLICATION_DOCUMENTS.${type.toUpperCase()}`),
    });
  }) ?? [];
